module.exports = __webpack_public_path__ + "assets/a83d79d0fa3796fbd3e1c3c03b06bbad.mp3";